import {Box, Card, Grid, Link, Stack, Typography} from "@mui/material";
import {Container} from "@mui/system";
import {useLocales} from "../../locales";
import {NavLink as RouterLink} from 'react-router-dom';
import Iconify from "../Iconify";
import useResponsive from "../../hooks/useResponsive";
import Image from "../image";

export default function Footer() {

    const {translate} = useLocales();

    const isMobile = useResponsive('down', 'sm');

    return (
        <Card
            sx={{
                backgroundImage: 'url("./assets/images/header.png")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%',
                borderRadius: 0,
                py: 5
            }}
        >
            <Container maxWidth="xl">
                {!isMobile ?
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                            <Typography sx={{
                                color: "white",
                                fontFamily: 'Montserrat',
                                fontSize: '14px',
                                fontWeight: 400,
                                lineHeight: '1.5'
                            }}>
                                Javno gradsko saobraćajni preduzeće Novi Sad <br/>
                                21137 Novi Sad, Futoški put 46 <br/>
                                gspns@gspns.rs <br/>
                                PIB: 100277648 <br/>
                                MB: 08041822
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} sx={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Box sx={{
                                mb: 2,
                                backgroundImage: 'url("./assets/images/logo.png")',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                height: "37px",
                                width: "91px",
                                borderRadius: 0,
                                flexShrink: 0
                            }}
                            />
                            <Stack direction="row" spacing={1.2}>
                                <Link
                                    noWrap
                                    underline="none"
                                    component={RouterLink}
                                    to={"https://google.rs"}
                                    sx={{
                                        fontFamily: 'Montserrat',
                                        fontSize: 13,
                                        typography: 'body2',
                                        color: 'white',
                                        transition: (theme) => theme.transitions.create('all'),
                                        '&:hover': {color: 'primary.main'},
                                    }}
                                >
                                    {translate("termsOfUse")}
                                </Link>
                                <Link
                                    noWrap
                                    underline="none"
                                    component={RouterLink}
                                    to={"https://google.rs"}
                                    sx={{
                                        fontFamily: 'Montserrat',
                                        fontSize: "12px",
                                        typography: 'body2',
                                        color: 'white',
                                        transition: (theme) => theme.transitions.create('all'),
                                        '&:hover': {color: 'primary.main'},
                                    }}
                                >
                                    {translate("privatePolicy")}
                                </Link>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} sx={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                            textAlign: 'right',
                        }}>
                            <Stack spacing={2}>
                                <Stack direction="row" spacing={1.2} alignItems="center" justifyContent="flex-end">
                                    <Iconify  color="white" icon="mdi:instagram" width={17} sx={{mr: 1.5}}></Iconify>
                                    <Typography sx={{
                                        alignItems: 'center',
                                        color: "white",
                                        fontFamily: 'Montserrat',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        lineHeight: 'normal'
                                    }}>
                                        INSTAGRAM
                                    </Typography>
                                </Stack>
                                <Stack direction="row" spacing={1.2} alignItems="center" justifyContent="flex-end">
                                    <Iconify color="white" icon="ant-design:facebook-outlined" width={17} sx={{mr: 3}}/>
                                    <Typography sx={{
                                        color: "white",
                                        fontFamily: 'Montserrat',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        lineHeight: 'normal'
                                    }}>
                                        FACEBOOK <br/>
                                    </Typography>
                                </Stack>
                                <Typography sx={{
                                    alignItems: 'center',
                                    color: "white",
                                    fontFamily: 'Montserrat',
                                    fontSize: '12px',
                                    fontWeight: 400,
                                    lineHeight: 'normal'
                                }}>
                                    © 2023 JGSP Novi Sad
                                </Typography>

                            </Stack>
                        </Grid>
                    </Grid> :
                    <Box sx={{
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 2
                    }}>
                        <Image sx={{width: 91, height: 37}} alt="appStore" src="/assets/images/logo.png"/>
                        <Stack direction="row" spacing={1.2}>
                            <Link
                                noWrap
                                underline="none"
                                component={RouterLink}
                                to={"https://google.rs"}
                                sx={{
                                    fontFamily: 'Montserrat',
                                    fontSize: 13,
                                    typography: 'body2',
                                    color: 'white',
                                    transition: (theme) => theme.transitions.create('all'),
                                    '&:hover': {color: 'primary.main'},
                                }}
                            >
                                {translate("termsOfUse")}
                            </Link>
                            <Link
                                noWrap
                                underline="none"
                                component={RouterLink}
                                to={"https://google.rs"}
                                sx={{
                                    fontFamily: 'Montserrat',
                                    fontSize: "12px",
                                    typography: 'body2',
                                    color: 'white',
                                    transition: (theme) => theme.transitions.create('all'),
                                    '&:hover': {color: 'primary.main'},
                                }}
                            >
                                {translate("privatePolicy")}
                            </Link>
                        </Stack>

                        <Typography sx={{
                            color: "white",
                            fontFamily: 'Montserrat',
                            fontSize: '12px',
                            fontWeight: 400,
                            lineHeight: 'normal'
                        }}>
                            © 2023 JGSP Novi Sad
                        </Typography>
                    </Box>


                }

            </Container>
        </Card>
    )
}